export default "assets/images/icons/pinterest-df87cbc7.svg";